import gql from "graphql-tag";

export const RESET_PASSWORD = gql`

mutation userForgetPassword($email: String, $mobile_number: String) {
    userForgetPassword(input: { email: $email, mobile_number: $mobile_number }) {
      success
      message
    }
  }
`;
